import * as React from 'react';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const SkeletonLoading: React.FC = () => {
  return (
    <Box height='100%' display='flex' p={4} flexDirection='column'>
      <Box display='flex' alignItems='center' gap={2}>
        <Skeleton variant='circular' width={56} height={56} />
        <Skeleton variant='text' width={240} height={40} sx={{ fontSize: '1rem' }} />
      </Box>

      <Stack direction='row' spacing={2} sx={{ mt: 3 }}>
        {[...Array(4)].map((x, i) => (
          <Skeleton key={i} variant='rounded' height={120} sx={{ flex: 1 }} />
        ))}
      </Stack>
    </Box>
  );
};

export default SkeletonLoading;
